/** @type {import("keycloak-js").Keycloak | null} */
let keycloakRef = null;

let logoutInProgress = false;

/** @param {import("keycloak-js").Keycloak | null} kc */
export function setKeycloakInstance(kc) {
  keycloakRef = kc;
}

/** @returns {import("keycloak-js").Keycloak | null} */
export function getKeycloakInstance() {
  return keycloakRef;
}

export function setLogoutInProgress(value) {
  logoutInProgress = value;
}

export function isLogoutInProgress() {
  return logoutInProgress;
}
